import React, { forwardRef } from 'react';
import { Location } from 'history';
import { Link } from 'react-router-dom';
import { classes } from '../../../../utils/commonUtils';
import { DetailsLink } from '../../details-link';
import { InputContext } from '../../use-input-context';
import { DetailsParams } from '../../utils';
import css from './action-button.module.scss';

interface BaseActionButtonProps {
  variant: 'bordered' | 'ghost';
  children: React.ReactNode;
  className?: string;
}

interface ActionButtonProps extends BaseActionButtonProps {
  onClick: () => void;
}

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ children, onClick, variant, className }, ref) => {
    return (
      <button ref={ref} type="button" onClick={onClick} className={classes(css.button, css[variant], className)}>
        {children}
      </button>
    );
  },
);

interface Params extends Partial<InputContext & Pick<DetailsParams, 'subType'>> {
  season?: string;
}

interface LinkActionLinkProps extends BaseActionButtonProps {
  as: 'link';
  to: Location<unknown> | string;
}

interface DetailsActionLinkProps extends BaseActionButtonProps {
  as: 'details';
  options: DetailsParams;
  params?: Params;
}

export type ActionLinkProps = LinkActionLinkProps | DetailsActionLinkProps;

export const ActionLink = forwardRef<HTMLAnchorElement, ActionLinkProps>((props, ref) => {
  if (props.as === 'details') {
    const { options, params, children, variant, className } = props;
    return (
      <DetailsLink
        ref={ref}
        id={options.id}
        type={options.type}
        subType={options.subType}
        params={params}
        className={classes(css.button, css[variant], className)}
      >
        {children}
      </DetailsLink>
    );
  }

  const { to, children, variant, className, ...rest } = props;

  return (
    <Link ref={ref} to={to} className={classes(css.button, css[variant], className)} {...rest}>
      {children}
    </Link>
  );
});
